import { Route, Routes } from "react-router-dom";
import MemberSignIn from "routes/account/signIn/MemberSignIn";
import AppRedirect from "routes/account/signUp/AppRedirect";
import MemberSignUp from "routes/account/signUp/MemberSignUp";
import OrderComplete from "routes/front/main/order/OrderComplete";
import MobileMypage from "routes/front/main/vending/MobileMypage";
import Test2PagePaymentFail from "routes/front/test/Test2PagePaymentFail";
import Test2PaymentComplete from "routes/front/test/Test2PaymentComplete";
import TestPage from "routes/front/test/TestPage";
import TestPage2 from "routes/front/test/TestPage2";
import TestPage2Payment from "routes/front/test/TestPage2Payment";
import TestPageResult from "routes/front/test/TestPageResult";
import TestPaymentPage from "routes/front/test/TestPaymentPage";
import { ADMIN, VENDOR } from "shared/Roles";
import AdminRouter from "./AdminRouter";
import FrontRouter from "./FrontRouter";
import VendorRouter from "./VendorRouter";
import ResponsiveHome from "routes/main/home/ResponsiveHome";
import ModalTestPage from "routes/front/test/ModalTestPage";
import TermsOfUse from "routes/policy/TermsOfUse";
import MobileSignUpComplete from "routes/front/mobile/MobileSignUpComplete";
import TestadminApp from "routes/front/test/TestadminApp";


function RootRouter(props) {
    return (
        <Routes>
            <Route path={"/*"} element={<FrontRouter />} />
            <Route path={"/vendor/*"} element={<VendorRouter allowedRoles={[VENDOR, ADMIN]} />} />
            {/* <Route path={"/vendor/*"} element={<VendorRouter />} /> */}
            <Route path={"/admin/*"} element={<AdminRouter allowedRoles={[ADMIN]} />} />
            {/* <Route path={"/admin/*"} element={<AdminRouter />} /> */}
            {/* <Route path="order">
                <Route path="complete" element={<OrderComplete />} />
            </Route>
            <Route path="payment" element={<TestPage2Payment />} />
            <Route path="payment/fail" element={<Test2PagePaymentFail />} />
            <Route path="test2" element={<TestPage2 />} />
            <Route path="test2/payment" element={<TestPage2Payment />} />
            <Route path="test2/payment/complete" element={<Test2PaymentComplete />} />
            <Route path="test2/payment/fail" element={<Test2PagePaymentFail />} /> */}
            {/* <Route path="test" element={<TestPage />} /> */}
            {/* <Route path="modalTest" element={<ModalTestPage />} /> */}
            {/* <Route path="testPayment" element={<TestPaymentPage />} /> */}
            

        </Routes>
    );
}

export default RootRouter;